import {
  PLAID_LOAD_LINK_TOKEN,
  PLAID_LINK_TOKEN_SUCCESS,
  PLAID_LINK_TOKEN_ERROR,
  PLAID_CONNECTING,
  PLAID_ACCOUNT_DATA_RECEIVED,
  PLAID_CONNECTED,
  PLAID_ERROR,
  PLAID_RESET,
  PLAID_STATUS,
} from '../constants';

const initialState = {
  status: PLAID_STATUS.NotStarted,
  linkToken: null,
  expiration: null,
  requestId: null,
  publicToken: null,
  accountData: null,
  error: null,
};

export default function plaid(state = initialState, action) {
  switch (action.type) {
    case PLAID_LOAD_LINK_TOKEN:
      return { ...state, status: PLAID_STATUS.LoadingLinkToken, error: null };
    case PLAID_LINK_TOKEN_SUCCESS:
      return {
        ...state,
        status: PLAID_STATUS.ReadyToConnect,
        linkToken: action.payload.linkToken,
        expiration: action.payload.expiration,
        requestId: action.payload.requestId,
      };
    case PLAID_LINK_TOKEN_ERROR:
      return { ...state, status: PLAID_STATUS.Error, error: action.payload };
    case PLAID_CONNECTING:
      return { ...state, status: PLAID_STATUS.Connecting };
    case PLAID_ACCOUNT_DATA_RECEIVED:
      return {
        ...state,
        status: PLAID_STATUS.VerifyingAccount,
        publicToken: action.payload.publicToken,
        accountData: action.payload.metadata,
      };
    case PLAID_CONNECTED:
      return { ...state, status: PLAID_STATUS.Connected, accountData: action.payload };
    case PLAID_ERROR:
      return { ...state, status: PLAID_STATUS.Error, error: action.payload };
    case PLAID_RESET:
      return initialState;
    default:
      return state;
  }
}
